export default __webpack_public_path__ + "static/media/ynet-black.34eaef25.svg";